import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { API } from "../config/api-config";
import { HttpService } from "../service/http-service";

@Component({
  selector: "app-enroll-record-list",
  templateUrl: "./enroll-record-list.component.html",
  styleUrls: ["./enroll-record-list.component.css"],
})
export class EnrollRecordListComponent implements OnInit {
  public pageData: object = {};
  public page = { pageNumber: 1 };
  public imagePath: string;
  public courseList = [];
  public searchValue: any = {
    memberId: "",
    mobile: "",
    courseId: "",
  };

  constructor(private httpService: HttpService, private router: Router) {}

  ngOnInit() {
    this.getPath();
    this.getData();
    this.getCourseData();
  }

  public data: Array<any> = [];

  getData(isSearch = false) {
    let data = { ...this.page };
    data.pageNumber--;
    if (isSearch) {
      let searchdata = {};
      for (let k in this.searchValue) {
        if (this.searchValue[k]) {
          searchdata[k] = this.searchValue[k];
        }
      }
      data = { ...data, ...searchdata };
    }
    this.httpService.getData(API.enrollRecord, data).then((response) => {
      this.pageData = response.data;
      this.data = response.data.content;
    });
  }

  private getCourseData(isSearch = false) {
    this.httpService.getData(API.course, { pageSize: 9999 }).then((res) => {
      this.courseList = res.data.content;
    });
  }

  private getPath(): void {
    this.httpService.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      this.getData();
    });
  }

  public pageChange(e: any) {
    this.page = e;
    this.getData(true);
  }

  public view(id) {
    this.router.navigate(["/index/enrollrecord", id]);
  }

  private debounce(fn, wait) {
    var timer = null;
    return function () {
      if (timer !== null) {
        clearTimeout(timer);
      }
      timer = setTimeout(fn, wait);
    };
  }

  public search(text) {
    this.debounce(() => {
      console.log(text);
    }, 300);
  }

  public searchData() {
    this.page.pageNumber = 1;
    this.getData(true);
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/enroll-record-list/enroll-record-list.component.ts